<template>
  <div id="Events">
    <el-tabs tab-position="left" v-model="activeTabName">
      <el-tab-pane
        v-for="group in eventYears"
        :key="group.year"
        :label="group.year"
        :name="group.year"
      >
        <div class="list-group">
          <div class="list-group-item active">{{ group.year }} Events</div>
          <router-link
            v-for="event in group.items"
            :key="event.route"
            :to="event.route"
            class="list-group-item"
          >
            {{ event.title }}
          </router-link>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { eventYears } from '../data/events';

export default {
  name: 'Events',
  data() {
    return {
      activeTabName: eventYears[0].year,
      eventYears
    };
  }
};
</script>

<style lang="less" scoped>
#Events {
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 2.2rem auto 0;
  position: relative;
  word-spacing: 0.3px;
  min-height: 700px;
}

.list-group-item {
  font-size: 1rem;
  font-weight: bold;
}

.list-group-item.active {
  background-color: #1a80b6;
  border-color: #1a80b6;
}

a {
  text-decoration: none;
}
</style>
